export enum DistanceBoundaryInKm {
    DEFAULT = 100,
    MIN = 1,
    MAX = 500,
}
